// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import messages from './lang'
import Buefy from 'buefy'
import VueResource from 'vue-resource'
import VueI18n from 'vue-i18n'
import 'buefy/lib/buefy.css'

Vue.use(VueResource)
Vue.use(VueI18n)
Vue.use(Buefy)

let locale = navigator.language
if (window.localStorage.getItem('language')) {
  locale = window.localStorage.getItem('language')
}

const i18n = new VueI18n({
  fallbackLocale: 'en',
  locale: locale,
  messages
})

Vue.http.interceptors.push((request, next) => {
  let token = window.localStorage.getItem('token')
  console.log(token)
  request.headers.set('Authorization', 'Bearer ' + token)
  next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js